/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  UncontrolledTooltip,
  Spinner,
  Button,
} from "reactstrap";

import Switch from "react-switch";

//Import component inputTime
import InputTime from "../../components/Skills/ChatEvent/inputTime";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";

//yupResolver
import { yupResolver } from "@hookform/resolvers/yup";

import { useForm } from "react-hook-form";

import "./Features.scss";

import schema from "./FeatureValidation.js";

import {
  getFeatures,
  editFeature,
  resetFeature,
  resetFeatures,
  resetError,
} from "../../store/features/actions";

import { updateFeaturesSuccess } from "../../store/auth/login/actions";

const Features = ({ t }) => {
  const dispatch = useDispatch();

  const {
    dataFeature,
    dataFeatureEditCreate,
    loadingFeature,
    loadingFeatureEditCreate,
    successFeature,
    errorFeature,
  } = useSelector((state) => state.Feature);

  const { register, handleSubmit, errors, setValue } = useForm({
    resolver: yupResolver(schema),
  });

  const [newFields, setNewFields] = useState();

  const [selectedFeature, setSelectedFeature] = useState(null);

  const [selectedFeatureConfig, setSelectedFeatureConfig] = useState(null);

  const [featureValues, setFeatureValues] = useState({
    features: [],
  });

  const mainTheme = useSelector((state) => state.Layout.mainTheme);

  const showToast = useCallback(
    (type, message) => {
      toastr[type](message);
    },
    [successFeature]
  );
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () => successFeature && dispatch(resetFeature()),
  };

  const newFeatureConfigSubmit = () => {
    setNewFields({
      ...selectedFeatureConfig,
    });
    setSelectedFeatureConfig(null);
  };

  useEffect(() => {
    dispatch(resetError());
    dispatch(resetFeatures());
    dispatch(getFeatures(null, null, null, true));
  }, []);

  useEffect(() => {
    if (dataFeature?.features && !loadingFeature) {
      setFeatureValues({
        ...featureValues,
        features: dataFeature.features,
      });
    }
  }, [dataFeature]);

  useEffect(() => {
    if (selectedFeatureConfig) {
      const value = selectedFeatureConfig?.config?.timeout?.map((e) => e.value);
      setValue("config", value, {
        shouldValidate: true,
      });
    }
  }, [selectedFeatureConfig]);

  useEffect(() => {
    if (dataFeatureEditCreate?.message) {
      showToast("success", t(dataFeatureEditCreate.message));
      const value = featureValues.features.map((element) =>
        element.id === newFields?.id ? { ...element, ...newFields } : element
      );
      dispatch(updateFeaturesSuccess(value));
      //UPDATE local values (feturevalues, selectedfeatures) if success
      setFeatureValues({
        ...featureValues,
        features: value,
      });
      if (selectedFeature) {
        setSelectedFeature({ ...selectedFeature, ...newFields });
      }
    }
  }, [successFeature]);

  useEffect(() => {
    if (errorFeature && Array.isArray(errorFeature)) {
      errorFeature.map((error) => showToast("error", t(error.value)));
      dispatch(resetError());
    } else {
      if (errorFeature) {
        showToast("error", t(errorFeature));
        dispatch(resetError());
      }
    }
  }, [errorFeature]);

  useEffect(() => {
    if (newFields) {
      let valuesToSend = { ...newFields };
      delete valuesToSend.id;
      delete valuesToSend.name;
      valuesToSend.config = !valuesToSend.config ? {} : valuesToSend.config;

      dispatch(editFeature(newFields.id, valuesToSend));
    }
  }, [newFields]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/dashboard"
            path={"/features"}
            title={t("Dashboard")}
            breadcrumbItem={t("Features")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody className="card-height">
                  <Row className="h-100">
                    <Col className="h-100" md="4">
                      <Label>{t("Features")}</Label>
                      <div className={`feature-card mb-2 ${mainTheme}`}>
                        <div className="feature-card-child">
                          {!loadingFeature &&
                          featureValues?.features?.length > 0 ? (
                            featureValues.features.map((element, key) => (
                              <Row
                                key={key}
                                className={`feature-content ${
                                  selectedFeature?.id === element?.id
                                    ? "active"
                                    : ""
                                } mb-2 mx-1 ${mainTheme}`}
                                onClick={() => {
                                  setSelectedFeature(
                                    featureValues?.features[key]
                                  );
                                }}
                              >
                                <Col>
                                  <div className="feature-label pointer text-muted">
                                    {t(featureValues?.features[key].name)}
                                  </div>
                                </Col>
                                <Col className="align-self-center" sm="auto">
                                  <div
                                    id={`action-toggle-tooltip-${key}`}
                                    className={`feature-temp-div d-flex ${
                                      mainTheme === "light" && "toggle-light"
                                    }`}
                                    onClick={() => {
                                      if (
                                        featureValues?.features[key].name ===
                                        "Agent area information"
                                      ) {
                                        setNewFields({
                                          id: featureValues?.features[key].id,
                                          active:
                                            !featureValues?.features[key]
                                              .active,
                                          config: {
                                            ...featureValues?.features[key]
                                              .config,
                                          },
                                        });
                                      } else if (
                                        featureValues?.features[key].name ===
                                        "Tab"
                                      ) {
                                        setNewFields({
                                          id: featureValues?.features[key].id,
                                          active:
                                            !featureValues?.features[key]
                                              .active,
                                          config: {
                                            ...featureValues?.features[key]
                                              .config,
                                            required: true,
                                          },
                                        });
                                      } else {
                                        setNewFields({
                                          id: featureValues?.features[key].id,
                                          active:
                                            !featureValues?.features[key]
                                              .active,
                                          config: {
                                            ...featureValues?.features[key]
                                              .config,
                                          },
                                        });
                                      }
                                    }}
                                  >
                                    <Switch
                                      className="feature-temp-switch d-flex align-self-center"
                                      onColor="#34c38f"
                                      offColor="#bfc8e2"
                                      onHandleColor="#222736"
                                      offHandleColor="#32394E"
                                      checked={
                                        featureValues?.features[key].active
                                      }
                                      onChange={() => {}}
                                      handleDiameter={10}
                                      width={28}
                                      height={16}
                                      checkedIcon={false}
                                      uncheckedIcon={false}
                                      disabled
                                    />
                                  </div>
                                </Col>
                                <UncontrolledTooltip
                                  placement="auto"
                                  target={`action-toggle-tooltip-${key}`}
                                >
                                  {`${
                                    featureValues?.features[key].active
                                      ? t("Deactivate")
                                      : t("Activate")
                                  }`}
                                </UncontrolledTooltip>
                              </Row>
                            ))
                          ) : loadingFeature ? (
                            <div className="w-100 text-center text-muted">
                              {t("Loading...")}
                            </div>
                          ) : (
                            <div className="w-100 text-center text-muted">
                              {t("No matching feature found")}
                            </div>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col className="h-100" md="8">
                      <Label>{t("Settings")}</Label>
                      <div className={`feature-card mb-2 ${mainTheme}`}>
                        <div>
                          {!loadingFeature ? (
                            selectedFeature ? (
                              <div>
                                <Row className="px-3">
                                  <div
                                    className={`feature-description mb-2 ${mainTheme}`}
                                  >
                                    {selectedFeature.description
                                      ? t(`${selectedFeature.description}`)
                                      : t(
                                          "There are no description to this feature"
                                        )}
                                  </div>
                                </Row>
                                <Row className="px-3 mb-2">
                                  {selectedFeature?.config?.required && (
                                    <Col className="d-flex justify-content-end">
                                      <div
                                        className="feature-temp-div d-flex"
                                        onClick={() => {
                                          setNewFields({
                                            ...selectedFeature,
                                            required: !selectedFeature.required,
                                          });
                                        }}
                                      >
                                        <Switch
                                          className="feature-temp-switch d-flex align-self-center"
                                          onColor="#5673E6"
                                          offColor="#bfc8e2"
                                          onHandleColor="#222736"
                                          offHandleColor="#32394E"
                                          checked={selectedFeature.required}
                                          onChange={() => {}}
                                          handleDiameter={10}
                                          width={28}
                                          height={16}
                                          checkedIcon={false}
                                          uncheckedIcon={false}
                                          disabled
                                        />
                                        <div className="d-flex align-self-center ml-2">
                                          {t("Required")}
                                        </div>
                                      </div>
                                    </Col>
                                  )}
                                </Row>
                                <Row className="px-3 mb-2">
                                  {selectedFeature?.config?.hasOwnProperty(
                                    "queue_counter"
                                  ) &&
                                    selectedFeature?.config?.hasOwnProperty(
                                      "agents_status_view"
                                    ) && (
                                      <Col className="d-flex flex-column justify-content-end">
                                        <div
                                          className="feature-temp-div d-flex"
                                          onClick={() => {
                                            setNewFields({
                                              ...selectedFeature,
                                              config: {
                                                queue_counter:
                                                  !selectedFeature.config
                                                    .queue_counter,
                                                agents_status_view:
                                                  selectedFeature.config
                                                    .agents_status_view,
                                              },
                                            });
                                          }}
                                        >
                                          <Switch
                                            className="feature-temp-switch d-flex align-self-center"
                                            onColor="#5673E6"
                                            offColor="#bfc8e2"
                                            onHandleColor="#222736"
                                            offHandleColor="#32394E"
                                            checked={
                                              selectedFeature.config
                                                .queue_counter
                                            }
                                            handleDiameter={10}
                                            width={28}
                                            height={16}
                                            checkedIcon={false}
                                            uncheckedIcon={false}
                                            disabled
                                          />
                                          <div className="d-flex align-self-center ml-2">
                                            {t("Queue counter")}
                                          </div>
                                        </div>
                                        <div
                                          className="feature-temp-div d-flex"
                                          onClick={() => {
                                            setNewFields({
                                              ...selectedFeature,
                                              config: {
                                                queue_counter:
                                                  selectedFeature.config
                                                    .queue_counter,
                                                agents_status_view:
                                                  !selectedFeature.config
                                                    .agents_status_view,
                                              },
                                            });
                                          }}
                                        >
                                          <Switch
                                            className="feature-temp-switch d-flex align-self-center"
                                            onColor="#5673E6"
                                            offColor="#bfc8e2"
                                            onHandleColor="#222736"
                                            offHandleColor="#32394E"
                                            checked={
                                              selectedFeature.config
                                                .agents_status_view
                                            }
                                            handleDiameter={10}
                                            width={28}
                                            height={16}
                                            checkedIcon={false}
                                            uncheckedIcon={false}
                                            disabled
                                          />
                                          <div className="d-flex align-self-center ml-2">
                                            {t("Agents status view")}
                                          </div>
                                        </div>
                                      </Col>
                                    )}
                                </Row>
                                <Row className="px-4 mb-2">
                                  <form
                                    onSubmit={handleSubmit(
                                      newFeatureConfigSubmit
                                    )}
                                  >
                                    {selectedFeature?.config?.timeout?.map(
                                      (element, key) => (
                                        <Col className="d-flex justify-content-end">
                                          <div
                                            ref={() =>
                                              register({ name: "config" })
                                            }
                                          >
                                            <Label id="skill-inactive-time"></Label>
                                            <InputTime
                                              isSeconds={true}
                                              notHasBox={false}
                                              mb="mb-4"
                                              title={t(element.name) + " *"}
                                              tooltip={t(element.description)}
                                              id={`tooltip-${key}`}
                                              inputProps={{
                                                name: "skillinactivitytime",
                                                className: "form-control",
                                              }}
                                              defaultValue={element.value}
                                              onChange={(val) => {
                                                setSelectedFeatureConfig({
                                                  ...selectedFeature,
                                                  config: {
                                                    timeout:
                                                      selectedFeature.config.timeout.map(
                                                        (e) =>
                                                          e.id === element.id
                                                            ? {
                                                                ...e,
                                                                value:
                                                                  val.value,
                                                              }
                                                            : e
                                                      ),
                                                  },
                                                });
                                              }}
                                            />
                                            <div className="invalid-feedback d-block">
                                              {t(
                                                errors?.config?.[key]?.message
                                              )}
                                            </div>
                                          </div>
                                        </Col>
                                      )
                                    )}

                                    {selectedFeature?.config?.timeout && (
                                      <Button
                                        color="primary"
                                        className="mr-1 waves-effect waves-light"
                                        type="submit"
                                        id="showtoast"
                                        disabled={
                                          !selectedFeatureConfig ||
                                          errors?.config
                                        }
                                      >
                                        {loadingFeatureEditCreate ? (
                                          <Spinner
                                            size="sm"
                                            animation="border"
                                            style={{
                                              height: "19px",
                                              width: "19px",
                                            }}
                                          />
                                        ) : (
                                          t("Confirm")
                                        )}
                                      </Button>
                                    )}
                                  </form>
                                </Row>
                                <Row className="px-1">
                                  {selectedFeature?.config?.list?.map(
                                    (element, key) => (
                                      <Col
                                        key={key}
                                        xs="12"
                                        md="6"
                                        lg="4"
                                        className="p-2"
                                      >
                                        <div className="feature-content">
                                          <Row className="mb-1">
                                            <Col
                                              className="align-self-center pr-0"
                                              sm="auto"
                                            >
                                              <div
                                                className="feature-temp-div d-flex"
                                                onClick={() => {
                                                  setNewFields({
                                                    ...selectedFeature,
                                                    config: {
                                                      list: selectedFeature.config.list.map(
                                                        (e) =>
                                                          e.id === element.id
                                                            ? {
                                                                ...e,
                                                                active:
                                                                  !e.active,
                                                              }
                                                            : e
                                                      ),
                                                    },
                                                  });
                                                }}
                                              >
                                                <Switch
                                                  className="feature-temp-switch d-flex align-self-center"
                                                  onColor="#34c38f"
                                                  offColor="#bfc8e2"
                                                  onHandleColor="#222736"
                                                  offHandleColor="#32394E"
                                                  checked={element.active}
                                                  onChange={() => {}}
                                                  handleDiameter={10}
                                                  width={28}
                                                  height={16}
                                                  checkedIcon={false}
                                                  uncheckedIcon={false}
                                                  disabled
                                                />
                                              </div>
                                            </Col>
                                            <Col>
                                              <div className="feature-label">
                                                {t(element.name)}
                                              </div>
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col>
                                              <div className="feature-description mb-2">
                                                {element.description
                                                  ? t(`${element.description}`)
                                                  : t(
                                                      "There are no description to this feature"
                                                    )}
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                      </Col>
                                    )
                                  )}
                                </Row>
                              </div>
                            ) : (
                              <div className="w-100 text-center text-muted">
                                {t(
                                  "Click on any features on left side to show your settings"
                                )}
                              </div>
                            )
                          ) : (
                            <div className="w-100 text-center text-muted">
                              {t("Loading...")}
                            </div>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Features);